// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"90a6871a","637":"0faf9256","652":"9cfa4f32","680":"5e91e441","947":"36072f0c"}[chunkId] + ".chunk.js";
};